import { render, staticRenderFns } from "./Opt.vue?vue&type=template&id=1f15315b"
import script from "./Opt.vue?vue&type=script&lang=js"
export * from "./Opt.vue?vue&type=script&lang=js"
import style0 from "./Opt.vue?vue&type=style&index=0&id=1f15315b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports